import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  movieId: string;
  variant?: "solid" | "ghost";
}

export default function FavoriteButton({ movieId, variant = "solid" }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  const base =
    "inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors";

  if (variant === "ghost") {
    return (
      <button
        type="button"
        onClick={() => toggleFavorite(movieId)}
        aria-pressed={active}
        className={`${base} ${
          active
            ? "bg-accent-500 text-white hover:bg-accent-600"
            : "border border-background-50/30 text-background-100 hover:border-accent-400 hover:text-accent-300"
        }`}
      >
        <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"} aria-hidden="true" />
        {active ? "已收藏" : "收藏"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => toggleFavorite(movieId)}
      aria-pressed={active}
      className={`${base} ${
        active
          ? "bg-accent-500 text-white hover:bg-accent-600"
          : "bg-primary-100 text-primary-800 hover:bg-primary-200"
      }`}
    >
      <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"} aria-hidden="true" />
      {active ? "已收藏" : "收藏"}
    </button>
  );
}